export default function makeUniqueArray<T extends string | number | boolean>(array: T[]): T[] {
  // eslint-disable-next-line no-extra-boolean-cast
  return array.reduce((acc: T[], item: T): T[] => (!!acc.find((i: T) => item === i) ? acc : [...acc, item]), []);
}
